// src/components/LogoutButton.tsx
import React from "react";
import { signOut } from "firebase/auth";
import { auth } from "../firebase";
import { useNavigate } from "react-router-dom";
import { trackEvent } from "../utils/analytics.ts";

interface LogoutButtonProps {
  className?: string;
}

const LogoutButton: React.FC<LogoutButtonProps> = ({ className }) => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await signOut(auth);
      void trackEvent("logout");
      // Po odhlášení zpět na veřejnou úvodní stránku
      navigate("/");
    } catch (error) {
      console.error("Chyba při odhlašování:", error);
      alert("Odhlášení se nezdařilo. Zkuste to prosím znovu.");
    }
  };

  return (
    <button
      onClick={handleLogout}
      className={`px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700 transition-colors ${
        className || ""
      }`}
    >
      Odhlásit se
    </button>
  );
};

export default LogoutButton;
